import { render, staticRenderFns } from "./AutoDividendSetting.vue?vue&type=template&id=a5150b4e&scoped=true"
import script from "./AutoDividendSetting.vue?vue&type=script&lang=js"
export * from "./AutoDividendSetting.vue?vue&type=script&lang=js"
import style0 from "./AutoDividendSetting.vue?vue&type=style&index=0&id=a5150b4e&prod&lang=scss&scoped=true"
import style1 from "./AutoDividendSetting.vue?vue&type=style&index=1&id=a5150b4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5150b4e",
  null
  
)

export default component.exports